import { 
	createSelector
} from '@reduxjs/toolkit';

/**
 * @description selects some data of the store
 * @param store, global store of the platform
 * @returns the logged user
 */
export const getRestaurant = (store: any): any => store.user.restaurant;

/**
 * @description selects some data of the store
 * @param store, global store of the platform
 * @returns the logged user
 */
export const getUser = (store: any): any => store.user.user;


/******************************************************************************/
/******************************** STORE ACTION ********************************/
/******************************************************************************/

/**
 * @description return some information of the store
 * @return the logged user
 */
export const selectRestaurant = createSelector([ getRestaurant ], (value) => value );

/**
 * @description return some information of the store
 * @return the logged user
 */
export const selectUser = createSelector([ getUser ], (value) => value );
